import {Dict} from "../Core/Reflection";
import {ItemModel, ItemType} from "./ItemModel";

export interface StorageModel {
    version: string;
    visited?:boolean;
    packageIndex?: number;
    items?: Dict<ItemType, ItemModel>;
    factVO?: Dict<ItemType, number>;
    completeActivityVO?: Dict<ItemType, number>;
}

export const Version = "1.0.6";